export default __webpack_public_path__ + "static/media/visa.1b11a7ec.svg";